<!-- ========== Left Sidebar Start ========== -->
<div class="left-side-menu">
  <div class="media justify-content-center user-profile my-lg-4 mt-2 mb-2 pl-0" (click)="goHome()">
    <h2 class="m-0 pro-user-name"><img src="assets/wivbi-logo-sidebar.jpg" /><span class="brand">wivbi</span></h2>
  </div>


  <div class="sidebar-content">
    <!--- Sidemenu -->
    <div appSlimScroll *ngIf="!isSidebarCondensed()">
      <div class="d-flex flex-column justify-content-between" style="height: 80vh;">
        <div>
          <sn-menu id="sidebar-menu"></sn-menu>
        </div>
        <div>
          <sn-submenue id="sidebar-menu"></sn-submenue>
        </div>
      </div>
    </div>

    <div *ngIf="isSidebarCondensed()">
      <div class="d-flex flex-column justify-content-between" style="height: 80vh;">
        <div>
          <sn-menu id="sidebar-menu"></sn-menu>
        </div>
        <div>
          <sn-submenue id="sidebar-menu"></sn-submenue>

        </div>
      </div>
    </div>

    <!-- End Sidebar -->
    <div class="clearfix"></div>
  </div>
  <!-- Sidebar -left -->
</div>
<!-- Left Sidebar End -->
